import { defineComponent, reactive, computed } from 'vue';
import { BaseSlider, Image2 } from '@hems/component';
import { Helper } from '@hems/util';
export default defineComponent({
    name: 'TemperatureControl',
    components: {
        BaseSlider,
        Image2,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            data: computed(() => props.data),
        });
        const onMinus = () => {
            if (state.data?.setValue && state.data.minValue) {
                if (state.data.setValue > state.data.minValue) {
                    state.data.setValue = state.data.setValue - 1;
                }
            }
        };
        const onPlus = () => {
            if (state.data?.setValue && state.data.maxValue) {
                if (state.data.setValue < state.data.maxValue) {
                    state.data.setValue = state.data.setValue + 1;
                }
            }
        };
        return {
            state,
            onMinus,
            onPlus,
            toFixed: Number.prototype.toFixed,
            formatNumber: Helper.formatNumber,
        };
    },
});
